<template>
  <div class="h-auto ml-0 w-full lg:mr-3 min-h-screen overflow-x-auto">
    <div class="bg-white mx-3 mt-3 rounded-t-md border-b-0.5">
      <div class="flex justify-between items-center p-3">
        <p class="font-semibold">Setups for HR System</p>
      </div>
    </div>
    <div
      class="flex justify-start divide-x-1.5 bg-gray-50 mx-3 mb-5 items-center"
    >
      <router-link
        :to="{ name: 'setups', params: { type: menu.route } }"
        v-for="(menu, index) in subMenus"
        :key="index"
        :class="{
          'bg-primary text-white': selectedSubMenu == menu.name,
        }"
        class="text-sm text-center hover:bg-primary hover:text-white cursor-pointer p-3"
      >
        {{ menu.name }}
      </router-link>
    </div>
    <Emails :key="eKey" v-if="selectedSubMenu == 'Email Gateways'"></Emails>
    <SMSs :key="sKey" v-if="selectedSubMenu == 'SMS Gateways'"></SMSs>
    <Licensing :key="lKey" v-if="selectedSubMenu == 'Licensing'"></Licensing>
  </div>
</template>

<script>
import Emails from "@/components/AdminSetups/email/emails.vue";
import SMSs from "@/components/AdminSetups/sms/sms.vue";
import Licensing from "@/components/AdminSetups/licensing/licensing.vue";
export default {
  name: "AdminSetups",
  components: {
    Emails,
    SMSs,
    Licensing,
  },
  data() {
    return {
      eKey: 0,
      sKey: 1,
      lKey: 2,
      selectedSubMenu: "Email Gateways",
      subMenus: [
        {
          name: "Email Gateways",
          route: "emails",
        },
        {
          name: "SMS Gateways",
          route: "sms",
        },
        {
          name: "Licensing",
          route: "licensing",
        },
      ],
    };
  },
  watch: {
    $route(to) {
      this.subMenus.forEach((menu) => {
        if (menu.route == to.params.type) {
          this.selectedSubMenu = menu.name;
        }
      });
      switch (this.selectedSubMenu) {
        case "Email Gateways":
          this.eKey++;
          break;
        case "SMS Gateways":
          this.sKey++;
          break;
        case "Licensing":
          this.lKey++;
          break;
      }
    },
  },
};
</script>
